import React, { FC, ReactNode } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { Dialog } from '../dialog';
import { NotificationBanner } from '../notificationBanner';
import Loader from '../loader';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { aiLimitGuardQuery } from './__generated__/aiLimitGuardQuery.graphql';

const CenteredContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 40px 20px;
    min-height: 200px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
`;

interface AILimitGuardProps {
    onClose: () => void;
    children: ReactNode;
}

export const AILimitGuard: FC<AILimitGuardProps> = ({ onClose, children }) => {
    const aiLimited = useLazyLoadQuery<aiLimitGuardQuery>(
        graphql`
            query aiLimitGuardQuery {
                checkAILimited
            }
        `,
        {},
        { fetchPolicy: 'network-only' }
    );

    if (!aiLimited) {
        return (
            <Dialog buttons={[{ label: T._('Close', 'Admin'), onClick: onClose }]}>
                <CenteredContent>
                    <Loader />
                </CenteredContent>
            </Dialog>
        );
    }

    if (aiLimited.checkAILimited) {
        return (
            <Dialog buttons={[{ label: T._('Ok', 'Admin'), onClick: onClose }]}>
                <Container>
                    <NotificationBanner
                        title={T._('AI Limit Reached', 'Admin')}
                        type='CRITICAL'
                        content={T._(
                            "We're sorry, but it appears you have exceeded the allowed limit. It's important to adhere to the guidelines and limits set to ensure fair and safe usage of our services. If you need more info please contact support.",
                            'Admin'
                        )}
                    />
                </Container>
            </Dialog>
        );
    }

    return <>{children}</>;
};
